import * as _ from "lodash";
import { Intercom } from "../../common/intercom";
import { Utils } from "../../common/utils";
import { User } from "../../models/User";
import { BaseInternalView } from "../_BaseViews";

declare const App;
declare const CONFIG;

export class NavView extends BaseInternalView {
    private loggedIn = false;
    private currentOrg: number;
    private user: User;
    private firstRender = true;
    private ajaxCallMade = false;
    // private currentOrganizationFilter: string;

    private template = _.template(require("templates/nav/nav.html"));

    constructor(options) {
        super(
            <any>_.extend(options, {
                tagName: "div",
                className: "navbar__wrapper",
                events: {
                    "click #logout-link": "logout",
                    // "input #nav-org-filter-input": "organizationFilterChange",
                    "click .documentation-link": "documentationLinkClicked",
                },
            })
        );

        this.setTitle();
        this.listenTo(this.options.appCollection, "sync", () => {
            this.loggedIn = true;
        });
        this.listenTo(App.Bus, "switch:user", (user) => {
            if (this.user === user) return;
            this.user = user;
            this.loggedIn = true;
            // Only re-render if this is not the initial user load (navigation already rendered with user)
            if (this.firstRender === false) {
                this.render();
            }
        });
        this.listenTo(App.Bus, "switch:org", (organizationId) => {
            if (this.currentOrg === organizationId) return;
            this.currentOrg = organizationId;
            this.render();
        });
        this.listenTo(App.Bus, "setPageTitle", (pageTitle) => {
            this.setTitle(pageTitle);
        });
    }

    private documentationLinkClicked() {
        Intercom.trackEvent("viewed-documentation");
    }

    private setTitle(title?) {
        const el = document.getElementsByTagName("title")[0];
        el.text = (title ? title + " - " : "") + this.options.brandCollection.getBrand().get("name");
    }

    // * We moved this organization feature into the sidepanel,
    // * but some of this could possibly be used in the future as a tenant changer.
    // private handleAddOrganizationClick(e) {
    //     const li = $(e.currentTarget).parents("li");
    //     const orgId = Number(li.attr("data-org-id"));
    //     let org = null;

    //     if (orgId) {
    //         org = this.options.organizationCollection.findWhere({ id: orgId });
    //     }

    //     const view = new AddOrganizationModal(
    //         _.extend({}, this.options, {
    //             appCollection: this.options.appCollection,
    //             org: org,
    //             modelId: orgId,
    //         })
    //     );
    //     $(".modals").append(view.render().el);
    //     view.show();
    // }

    // private organizationFilterChange() {
    //     const lis = this.$("#nav-org-filter-dropdown .height-limited-nav-dropdown.filterable li").get();
    //     const filter = (<string>this.$("#nav-org-filter-input").val()).toLowerCase();
    //     lis.reverse();

    //     _.each(lis, (li) => {
    //         const org = $(li).attr("data-org-name").toLowerCase();

    //         if (org.indexOf(filter) !== -1) {
    //             $(li).removeClass("hidden");
    //         } else {
    //             $(li).addClass("hidden");
    //         }
    //     });

    //     this.currentOrganizationFilter = filter;
    // }

    render() {
        if (this.firstRender) {
            this.$el.html(this.template());
            this.firstRender = false;
        }

        Promise.all([
            Utils.loadAsset(`${window["CONFIG"].portal1.url}/ui25/fragments/common/nav/public/css/top.css`, "css"),
            Utils.loadAsset(`${window["CONFIG"].portal1.url}/ui25/fragments/common/nav/public/js/top.js`, "js"),
        ])
            .then(() => {
                // Only make AJAX call if it hasn't been made yet
                if (!this.ajaxCallMade) {
                    this.ajaxCallMade = true;
                    $.ajax({
                        url: `${window["CONFIG"].portal1.url}/ui25/fragments/common/nav/top`,
                        method: "GET",
                        beforeSend: function (xhr) {
                            (xhr as any)._source = "topNavigation";
                        },
                        success: function (response) {
                            if ($("#topFragmentContainer").is(":empty")) {
                                $("#topFragmentContainer").html(response);
                            }
                        },
                        error: function (xhr) {
                            console.error("Failed to fetch top navigation fragment:", xhr);
                        }
                    });
                }
            })
            .catch((error) => {
                console.error("An asset failed to load:", error);
            });

        return this;
    }

    remove() {
        return super.remove();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/nav/NavView.ts